import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { openIaDrawer } from "../../REDUX/actions/ia";
import { IaAssistantSvg } from "./IaIcons";
import IaDrawer from "./IaDrawer";
import "./Ia.css";

/**
 * Bouton flottant permanent, en bas a droite, plus le panneau qu'il ouvre.
 *
 * Monte dans App.js hors du routeur : disponible pour les 5 roles, y compris
 * les roles logistiques 3 et 4 qui ont leur propre routeur a route unique.
 * Masque tant que l'utilisateur n'est pas connecte.
 */
const IaLauncher = () => {
  const dispatch = useDispatch();
  const { t } = useTranslation("common");
  const { user } = useSelector((state) => state.userReducer);
  const { drawerOpen, streamingMessageId } = useSelector((state) => state.iaReducer);

  if (!user) return null;

  return (
    <>
      {/* Le bouton disparait pendant que le tiroir est ouvert : il se superpose
          sinon au bouton d'envoi du composer. La fermeture passe par la croix de
          l'en-tete, un clic hors du tiroir ou la touche Echap. */}
      {!drawerOpen && (
        <button
          type="button"
          className="iaLauncher br50 alignC"
          title={t("AI Assistant")}
          aria-label={t("AI Assistant")}
          onClick={() => dispatch(openIaDrawer())}
        >
          <IaAssistantSvg size={28} />

          {/* Pastille de generation en cours, visible meme tiroir ferme. */}
          {streamingMessageId && <span className="iaLauncherBadge" />}
        </button>
      )}

      <IaDrawer />
    </>
  );
};

export default IaLauncher;
